import { render, staticRenderFns } from "./home-estates.vue?vue&type=template&id=0f8f6136&scoped=true&"
import script from "./home-estates.vue?vue&type=script&lang=js&"
export * from "./home-estates.vue?vue&type=script&lang=js&"
import style0 from "./home-estates.vue?vue&type=style&index=0&id=0f8f6136&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f6136",
  null
  
)

export default component.exports